<template>
    <div v-if="showSplash" :class="opacityClass"
        class="splash-screen relative flex flex-col justify-center items-center bg-[#f2f1ed] w-screen h-screen fixed top-0 left-0 z-[9999] transition-opacity duration-500">

        <div v-if="!mainSplashImage && !footerSplashImage" class="absolute inset-0 flex items-center justify-center">
            <div class="h-10 w-10 rounded-full border-2 border-neutral-300 border-t-neutral-700 animate-spin"></div>
        </div>

        <img v-if="mainSplashImage" :src="mainSplashImage" alt="Main Splash Image" class="w-4/5 md:w-1/3 h-auto mb-8 md:mb-16">

        <img v-if="footerSplashImage" :src="footerSplashImage" alt="Bottom Splash Image" class="w-3/4 md:w-1/4 h-auto mb-2 md:mb-4">
    </div>
</template>


<script>
import { ref, onMounted } from "vue";
import { useStorageFile } from "@/composables/useStorageAssets";
import { storageFiles } from "@/config/storageSections";

export default {
    name: 'SplashComponent',
    setup() {
        const showSplash = ref(true);
        const opacityClass = ref("opacity-100");
        const { assetUrl: mainSplashImage } = useStorageFile(storageFiles.splashMain);
        const { assetUrl: footerSplashImage } = useStorageFile(storageFiles.splashFooter);

        onMounted(() => {
            setTimeout(() => {
                opacityClass.value = "opacity-0";
                setTimeout(() => {
                    showSplash.value = false;
                }, 500); // This should match the duration of the fade-out transition
            }, 2000);
        });

        return { showSplash, opacityClass, mainSplashImage, footerSplashImage };
    }
};
</script>
